export default __webpack_public_path__ + "static/media/worder-order-dashboard.3910bd9b.svg";